export const PasswordPlaceholder = '*jlx40dg6mpSESqZnu9wVJQ*';
export const PasswordFromPlan = 'jlx40dg6mpSESqZnu9wVJQ==';
export const MaxSymbolInBrief = 23;
